/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import cleanUpResponse from '@/util/cleanUpResponse';

export default async function GetAWPackage1901Info(awPackageId) {
  const response = await $.soap({
    body: {
        GetAWPackage1901Info: {
        $xmlns: 'http://dla.mil/ems/bpm/aw_package',
        AWPackageID: awPackageId
      }
    },
    blueprint: {
      id: '$..ID',
      periodOfPerformance: '$..PeriodOfPerformance',
      orgNameCustomer: '$..CustomerName',
      pocFirstNameCustomer: '$..CustomerPOCFirstName',
      pocLastNameCustomer: '$..CustomerPOCLastName',
      pocMiddleInitialCustomer: '$..CustomerPOCMiddleInitial',
      pocEmailCustomer: '$..CustomerPOCEmail',
      pocPhoneCustomer: '$..CustomerPOCPhone',
      pocFaxCustomer: '$..CustomerPOCFax',
      addressCustomer: {
        address1: '$..CustomerAddress1',
        buildingFloorNumber: '$..CustomerBuildingFloorNumber',
        roomPoleNumber: '$..CustomerRoomPoleNumber',
        city: '$..CustomerCity',
        zip: '$..CustomerZip',
        regionId: '$..CustomerRegionID',
        regionCode: '$..CustomerRegionCode',
        regionName: '$..CustomerRegionName'
      },
      orgNameVendor: '$..VendorName',
      pocFirstNameVendor: '$..VendorPOCFirstName',
      pocLastNameVendor: '$..VendorPOCLastName',
      pocMiddleInitialVendor: '$..VendorPOCMiddleInitial',
      pocEmailVendor: '$..VendorPOCEmail',
      pocPhoneVendor: '$..VendorPOCPhone',
      pocFaxVendor: '$..VendorPOCFax',
      addressVendor: {
        address1: '$..VendorAddress1',
        buildingFloorNumber: '$..VendorBuildingFloorNumber',
        roomPoleNumber: '$..VendorRoomPoleNumber',
        city: '$..VendorCity',
        zip: '$..VendorZip',
        regionId: '$..VendorRegionID',
        regionCode: '$..VendorRegionCode',
        regionName: '$..VendorRegionName'
      }
    }
  });
  cleanUpResponse(response);
  return response;
}
